export var ModalStyle = {
    main: {
        background: "rgba(255, 255, 255, 0.5)",
        position: "fixed",
        left: 0,
        top: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        zIndex: 100,
        overflow: "auto",
    },
    container: {
        position: "relative",
        maxWidth: "100%",
        maxHeight: "100%"
    },
    closeModal: {
        cursor: "pointer",
        position: "absolute",
        right: "11px",
        top: 0,
        fontSize: "40px",
        textAlign: "right",
        textDecoration: "none"
    }
};
export var BackgroundStyle = {
    video: {
        position: "absolute",
        left: 0,
        width: "100%",
        top: 0,
        height: "100%"
    }
};
export var second = 1000;
export var minute = second * 60;
export var hour = minute * 60;
export var day = hour * 24;
export var week = day * 7;
//# sourceMappingURL=constraints.js.map